import React, { useState } from 'react';
import { Button, Dropdown } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { BankOutlined } from '@ant-design/icons';

import { ModalState, ActionDefinition } from 'components/organism/crud';
import { ECountry } from 'models';
import { AppDispatch } from 'models/app-dispatch';
import { Organization, OrganizationType } from 'models/organization';
import { IState } from 'redux/reducers';
import { useSaveOrganisation } from './hooks';
import { NewOrganizationModal } from './organization-new-modal';
import * as AuthService from '../../../services/auth.service';
import * as OrganizationActions from '../../../redux/actions/organizations';

export function OrganizationDropdown() {
  const dispatch = useDispatch<AppDispatch>();
  const [dropdownVisible, setDropdownVisibile] = useState(false);
  const authState = useSelector((state: IState) => state.auth);

  // Default values when creating a new organization
  const obj: Partial<Organization> = {
    organizationType: OrganizationType.SoleTrader,
    idCountry: ECountry.Australia,
    isGstRegistered: false,
  };

  const { isSaving, create, form } = useSaveOrganisation();
  const [modalState, setModalState] = useState<ModalState>(ModalState.Hidden);
  const modalActions: ActionDefinition<Organization>[] = [
    {
      key: 'action-save',
      title: 'Save',
      icon: null,
      type: 'primary',
      canRender: () => modalState === ModalState.Edit,
      handler: async () => {
        try {
          const values = await form.validateFields();
          const org = await create(values);
          setModalState(ModalState.Hidden);
          onOrgSelected(org);
        } catch (e) {}
      },
    },
  ];

  const onOrgSelected = async (org: Organization) => {
    await AuthService.Switch({ idOrganization: org.id });
    dispatch(OrganizationActions.OrganizationSwitch(org));
    window.location.reload();
  };

  const panel = (
    <div style={{ padding: '10px', backgroundColor: '#fff', border: '1px solid #fff', borderRadius: '5px', display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
      {authState.organizations.map((org) => (
        <Button key={org.id} title={org.name} type="link" size="large" style={{ width: '100%' }} onClick={() => onOrgSelected(org)} disabled={authState.currentOrganization?.id === org.id}>
          {org.name}
          {authState.currentOrganization?.id === org.id ? <span style={{ fontSize: '12px' }}>&nbsp;&nbsp;(current)</span> : null}
        </Button>
      ))}
      <Button
        type="dashed"
        size="large"
        style={{ width: '100%' }}
        onClick={() => {
          setDropdownVisibile(!dropdownVisible);
          setModalState(ModalState.Edit);
        }}
      >
        New business
      </Button>
    </div>
  );

  return (
    <div>
      <div style={{ margin: '10px', color: '#ccc', fontSize: '11px', textTransform: 'uppercase' }}>Business</div>
      <Dropdown overlay={panel} trigger={['click']} placement="topRight" visible={dropdownVisible} onVisibleChange={() => setDropdownVisibile(!dropdownVisible)}>
        <Button type="link" className={`organization-dropdown ${dropdownVisible ? 'active' : ''}`} onClick={(e) => e.preventDefault()}>
          {authState.currentOrganization ? (
            <>
              <BankOutlined style={{ marginRight: '5px' }} />
              <span style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{authState.currentOrganization.name}</span>
            </>
          ) : (
            <span>Select a business</span>
          )}
        </Button>
      </Dropdown>
      <NewOrganizationModal obj={obj as Organization} form={form} actions={modalActions} saving={isSaving} modalState={modalState} setModalState={setModalState} />
    </div>
  );
}
